// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_modules_login_login_module_ts":"3cf3f126c1118042","src_app_modules_painel_painel_module_ts":"d0de64722c07f9bc","src_app_modules_backoffice_backoffice_module_ts":"e0370d774ed497b2"}[chunkId] + ".js";
};